import { useCallback } from "react";
import { useAppData } from "../contexts/appData.context";
import { formatNumber } from "../helpers/formatNumber.helper";

export const usePrices = () => {
    const { currentCulture } = useAppData();

    const formatPrice = useCallback(
        (price: number) => formatNumber(price, currentCulture, { decimals: 2 }),
        [currentCulture]
    );

    return {
        formatPrice,
    };
};
